import {
    CheckCircleIcon as CircleCheckIcon,
    TextICircleIcon as InfoIcon,
    ArrowsRotateCwHorizontalIcon as Loader2Icon,
    XCircleIcon as OctagonXIcon,
    ExclamationTriangleIcon as TriangleAlertIcon,
} from "@wags/ui/product-icons.tsx";

import { useTheme } from "next-themes";
import { Toaster as SonnerPrimitive, type ToasterProps, toast } from "sonner";

const Sonner = ({ ...props }: ToasterProps) => {
    const { theme = "system" } = useTheme();

    return (
        <SonnerPrimitive
            theme={theme as ToasterProps["theme"]}
            className="toaster group"
            icons={{
                success: <CircleCheckIcon className="size-4" />,
                info: <InfoIcon className="size-4" />,
                warning: <TriangleAlertIcon className="size-4" />,
                error: <OctagonXIcon className="size-4" />,
                loading: <Loader2Icon className="size-4 animate-spin" />,
            }}
            style={
                {
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                    "--border-radius": "var(--radius-toast)",
                } as React.CSSProperties
            }
            {...props}
        />
    );
};

export { Sonner, toast };
